import React from 'react'


const PremiumChoice = () => {
  return (
    <>
    <h1>Premium Choice Series</h1>
   
    </>
  )
}

export default PremiumChoice
